import { EditOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'
import { ButtonCommon, PopoverCommon } from '..'
import FormEditWordType from '../DictionaryModal/components/Dictionary/components/FormEditWordType/FormEditWordType'
const ActionWordTypeCommon = ({ onEditClick, record }) => {
	const handleEdit = () => {
		onEditClick && onEditClick(record)
	}
	return (
		<div>
			<PopoverCommon content={<FormEditWordType />} trigger="click">
				<ButtonCommon onClick={handleEdit}>
					<EditOutlined />
				</ButtonCommon>
			</PopoverCommon>
		</div>
	)
}
ActionWordTypeCommon.propTypes = {
	onEditClick: PropTypes.func,
	record: PropTypes.any,
}
export default ActionWordTypeCommon
